const TemplateTableRow = ({ template, languageMap, onRowClick }) => {
  return (
    <tr
      className="hover:bg-gray-50 transition duration-150 cursor-pointer"
      onClick={() => onRowClick(template)}
    >
      <td className="px-4 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-gray-900">{template.templateName}</div>
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{template.category}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
        {languageMap[template.language] || template.language}
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
        {template.headerType || "-"}
      </td>
      <td className="px-4 py-4 whitespace-nowrap">
        <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium capitalize ${
          template.status === "pending"   ? "bg-yellow-100 text-yellow-800" :
          template.status === "rejected"  ? "bg-red-100 text-red-800" :
          template.status === "approved"  ? "bg-blue-100 text-blue-800" :
          "bg-green-100 text-green-800"
        }`}>
          {template.status || "Pending"}
        </span>
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
        {new Date(template.createdAt).toLocaleDateString()}
      </td>
    </tr>
  );
};

export default TemplateTableRow;
